import React from "react";
import ProjectsSection from "../ProjectsSection/ProjectsSection";

const Projects = () => {
  return (
    <>
      <ProjectsSection></ProjectsSection>
    </>
  );
};

export default Projects;
